/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import CloseIcon from "@material-ui/icons/Close";
import DehazeIcon from "@material-ui/icons/Dehaze";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { headerDesignForSp, resetButtonStyles } from "./HeaderSpDisplay";

type Props = {
  uid: string;
  isDisplayLogo: boolean;
  domainLogo: JSX.Element;
  HeaderMenuItems: { name: string; link: string; display: boolean }[];
  toggleLoginMethod: () => void;
};
export const HeaderRedeemerDisplay: React.FC<Props> = (props) => {
  const classesHeaderForSp = headerDesignForSp();
  const history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigateTo = (path: string) => {
    setIsMenuOpen(false);
    history.replace(path);
  };

  return (
    <React.Fragment>
      <header css={classesHeaderForSp.header}>
        <div css={classesHeaderForSp.container}>
          <div
            css={classesHeaderForSp.openMenu}
            onClick={() => setIsMenuOpen(true)}
          >
            <DehazeIcon />
          </div>

          {props.isDisplayLogo && (
            <h1 css={classesHeaderForSp.logo}>{props.domainLogo}</h1>
          )}

          <div css={classesHeaderForSp.iconList}>
            {!props.uid && (
              <button
                id="login"
                css={resetButtonStyles}
                className={"putBadge"}
                onClick={props.toggleLoginMethod}
              >
                <ExitToAppIcon aria-label="Login" />
              </button>
            )}
          </div>
        </div>
      </header>

      {isMenuOpen && (
        <div css={overlayStyle} onClick={() => setIsMenuOpen(false)} />
      )}
      <div css={sideMenuStyle(isMenuOpen)}>
        <div css={sideMenuHeaderStyle}>
          <button css={resetButtonStyles} onClick={() => setIsMenuOpen(false)}>
            <CloseIcon style={{ color: "#fff" }} />
          </button>
        </div>
        <nav css={sideMenuNavStyle}>
          <button
            css={sideMenuLinkStyle}
            onClick={() => navigateTo("/qrcode-redeemer")}
          >
            QRコードリーダー
          </button>
          <button
            css={sideMenuLinkStyle}
            onClick={() => navigateTo("/qrcode-redeemer-settings")}
          >
            設定
          </button>
        </nav>
      </div>
    </React.Fragment>
  );
};

const overlayStyle = css({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 999,
});

const sideMenuStyle = (isOpen: boolean) =>
  css({
    position: "fixed",
    top: 0,
    left: 0,
    width: 260,
    height: "100%",
    backgroundColor: "#000",
    color: "#fff",
    zIndex: 1000,
    transform: isOpen ? "translateX(0)" : "translateX(-100%)",
    transition: "transform 0.3s ease",
    overflowY: "auto",
  });

const sideMenuHeaderStyle = css({
  display: "flex",
  justifyContent: "flex-end",
  padding: 12,
});

const sideMenuNavStyle = css({
  display: "flex",
  flexDirection: "column",
  padding: "0 16px",
});

const sideMenuLinkStyle = css({
  background: "none",
  border: "none",
  cursor: "pointer",
  textAlign: "left",
  color: "#fff",
  padding: "16px 0",
  borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
  fontSize: 14,
});
